__turbopack_context__.v({
  "backButton": "pageNotFound-module-scss-module__e-FQZa__backButton",
  "backgroundImage": "pageNotFound-module-scss-module__e-FQZa__backgroundImage",
  "container": "pageNotFound-module-scss-module__e-FQZa__container",
  "subTitle": "pageNotFound-module-scss-module__e-FQZa__subTitle",
  "title": "pageNotFound-module-scss-module__e-FQZa__title",
});
